// ANGULAR MODULE
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
// THIRD PARTY MODULE
import { CountdownModule } from 'ngx-countdown';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { FlutterBridgeService } from './core/services/flutter-bridge/flutter-bridge.service';

import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from './translation/translation.module';

// WALLET ACCOUNT SHARED MODULE
import { PaperOtpModule } from './shared/paper-otp/paper-otp.module';
import { PaperCurrencyModule } from './shared/pipes/paper-currency/paper-currency.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { WalletBindingComponent } from './pages/wallet-binding/wallet-binding.component';

// WALLET ACCOUNT SHARED COMPONENT
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';


// WALLET ACCOUNT CORE
import { WalletAccountCoreModule } from './core/wallet-account-core.module';
import { walletAccountModuleProvider } from './core/helpers/provider/module/fs-module.provider';
import { WalletBindingCallbackComponent } from './pages/wallet-binding-callback/wallet-binding-callback.component';

declare global {
  interface Window {
    AppChannel?: any;
  }
}
@NgModule({
  declarations: [
    AppComponent,
    AccessDeniedComponent,
    WalletBindingComponent,
    WalletBindingCallbackComponent
  ],
  imports: [
    TranslationModule,
    TranslateModule,
    BrowserModule,
    AppRoutingModule,
    WalletAccountCoreModule.forRoot(),
    BrowserModule,
    PaperOtpModule,
    MessagesModule,
    CountdownModule,
    ProgressSpinnerModule,
    ToastModule,
    PaperCurrencyModule,
  ],
  providers: [...walletAccountModuleProvider, FlutterBridgeService, MessageService, provideHttpClient(), provideAnimations()],
  bootstrap: [AppComponent],
})
export class AppModule {}
